import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBedConflict({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M1 .75a.75.75 0 01.743.648l.007.102v5.249h5.2V2.5a.75.75 0 01.648-.743L7.7 1.75H12a3.75 3.75 0 013.745 3.55l.005.2v9.2a.75.75 0 01-1.493.102l-.007-.102v-2.45H1.75v2.45a.75.75 0 01-1.493.102L.25 14.7V1.5A.75.75 0 011 .75zm13 7.5L1.75 8.249v2.501h12.5V8.5a.25.25 0 00-.193-.243L14 8.25zm-2-5H8.45v3.499L14 6.75c.085 0 .169.006.25.018V5.5a2.25 2.25 0 00-2.096-2.245L12 3.25zM4.3 2.3a1.6 1.6 0 110 3.2 1.6 1.6 0 010-3.2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBedConflict.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBedConflict.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBedConflict svgRef={ref} {...props} />);
export default ForwardRef;
